var _ = require('lodash');
var moment = require('moment');
var reasons = {
    price: {
        title: 'Price is'.toUpperCase(),
        why: [
            "It's in the sweet spot of your price range!"
        ],
        whyNot: [
            "It's not the coin that you're looking to spend."
        ]
    },
    whatsimportant: {
        walkability: {
            title: 'Convenience/Walkability is'.toUpperCase(),
            why: [
                'You can practically crawl to all the nearby spots!',
                'All the hot spots are just a stone’s throw away!'
            ],
            whyNot: [
                'You may have to charge your electric car to get anywhere in this neighborhood!',
                'Important points of interest are S P A C E D O U T.'
            ]
        },
        restaurants: {
            title: 'Restaurants are'.toUpperCase(),
            why: [
                'You may have to punch a new hole in your belt - this place has good grub!',
                'How do you spell Foodie Haven?',
                'Yelp just crashed! This place is off the charts!'
            ],
            whyNot: [
                'Hope you like to cook, the restaurants are slim pickin.'
            ]
        },
        outdoors: {
            title: 'Outdoors is'.toUpperCase(),
            why: [
                'Take a hike! No seriously, there’s lots of place to go!',
                'Parks ‘a Plenty! A picnic lover’s paradise!'
            ],
            whyNot: [
                'Hope you’re the indoors type.',
                'Dust off your Nintendo - you’re gonna need it!'
            ]
        }
    },
    schools: {
        title: 'Schools are'.toUpperCase(),
        why: [
            'Harvard, here we come!',
            'Perfect for all the future Einsteins of America.'
        ],
        whyNot: [
            'These schools may not meet your demanding standards.'
        ]
    },
    hometype: {
        attached: {
            title: 'Home Type is'.toUpperCase(),
            why: [
                "You know what they say, 'One wall is better than two!'"
            ],
            whyNot: [
                'One is the loneliest number. This house is all by itself!'
            ]
        },
        detached: {
            title: 'Home Type'.toUpperCase(),
            why: [
                'No need to worry about nosy neighbors!',
                "Don't be afraid to sing in the shower, this baby's detached!"
            ],
            whyNot: [
                'Sharing is a virtue...unfortunately that includes walls.'
            ]
        }
    },
    bedrooms: {
        '1': {
            title: 'Bedrooms are'.toUpperCase(),
            why: [
                'Comfortably Cozy'
            ],
            whyNot: [
                "Let's just say you'll never be short of storage space."
            ]
        },
        '2': {
            title: 'Bedrooms are'.toUpperCase(),
            why: [
                'Congratulations! This home fulfills all your Bedrooming needs.'
            ],
            whyNot: [
                "Not the dynamic duo of bedrooms you're looking for."
            ]
        },
        '3': {
            title: 'Bedrooms are'.toUpperCase(),
            why: [
                'One bed per Amigo.'
            ],
            whyNot: [
                "Looks like three wasn't a charm on this one!"
            ]
        },
        '2-3': {
            title: 'Bedrooms are'.toUpperCase(),
            why: [
                'Congratulations! This home fulfills all your Bedrooming needs.'
            ],
            whyNot: []
        },
        '4+': {
            title: 'Bedrooms are'.toUpperCase(),
            why: [
                'Finally...enough room for both your Craft Room AND your scrapbooking room!'
            ],
            whyNot: [
                'Yeah, um...no.'
            ]
        }
    },
    bathrooms: {
        '1-2': {
            title: 'Bathrooms are'.toUpperCase(),
            why: [
                "1-2 Baths for your #1's and #2's"
            ],
            whyNot: [
                "That's a lot of hand soap!"
            ]
        },
        '3-4': {
            title: 'Bathrooms are'.toUpperCase(),
            why: [
                'Plenty of places to do your business.'
            ],
            whyNot: []
        },
        '5+': {
            title: 'Bathrooms are'.toUpperCase(),
            why: [
                'A different bathroom for every weekday.'
            ],
            whyNot: [
                "Think of all the calories you'll burn doing the 'Pee Dance'."
            ]
        }
    },
    age: {
        '< 10': {
            title: 'Age of Home is'.toUpperCase(),
            why: [
                "It still has that 'New Home' scent."
            ],
            whyNot: [
                'This home already had its mid-life crisis!',
                'This home has lots of...character.'
            ]
        },
        '10-50': {
            title: 'Age of Home is'.toUpperCase(),
            why: [
                "It's no spring chicken, but it sure ain't over the hill!"
            ],
            whyNot: []
        },
        '50+': {
            title: 'Age of Home is'.toUpperCase(),
            why: [
                'An older home built in simpler times.'
            ],
            whyNot: []
        }
    },
    stories: {
        '1': {
            title: 'Stories is'.toUpperCase(),
            why: [
                'This home is on the level. ONE level, that is.',
                'No stairs? I’m there!'
            ],
            whyNot: [
                "You mean there's an UPstairs?!",
                'Two stories? Too many.'
            ]
        },
        '2+': {
            title: 'Stories is'.toUpperCase(),
            why: [
                'Double the stories, double the fun!'
            ],
            whyNot: [
                'So many stories to tell, but not enough on this house.'
            ]
        }
    },
    sqfeet: {
        title: 'Square Feet is'.toUpperCase(),
        why: [
            'Not too big, not too small, it’s juuuuust right.'
        ],
        whyNot: [
            'In this case, size DOES matter.'
        ]
    },
    lotsize: {
        small: {
            title: 'Lot/Yard Size is'.toUpperCase(),
            why: [
                'Compact and easy to maintain.'
            ],
            whyNot: [
                'Honey, where did I put the tractor?'
            ]
        },
        medium: {
            title: 'Lot/Yard Size is'.toUpperCase(),
            why: [
                'I see a garden in your future.'
            ],
            whyNot: []
        },
        large: {
            title: 'Lot/Yard Size is'.toUpperCase(),
            why: [
                "Plenty of room to stretch your legs...if you're Gulliver."
            ],
            whyNot: [
                'So much for the farm!'
            ]
        }
    }
};

/*
Returns a formatted value

@function formatValue
@param {Listing} listing
@param {Boolean} metThreshold
@param {String} key - ex. whatsimportant
@param {*} value - The value that was selected for the key
*/
function formatValue(listing, metThreshold, key, value) {
    switch(key) {
        case 'price':
            return '$' + String(listing.price).replace(/[^0-9]+/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',');

        case 'whatsimportant':
        case 'schools':
            return metThreshold ? 'Very Good' : 'Poor';

        case 'bedrooms':
            return listing.beds + 'bd';

        case 'bathrooms':
            return listing.baths + 'ba';

        case 'age':
            return moment().diff(listing.year + '-01-01', 'years') + ' Years';

        case 'stories':
            return listing.floors + ' ' + (listing.floors === 1 ? 'Story' : 'Stories');

        case 'sqfeet':
            return String(listing.home_size).replace(/[^0-9]+/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',') + ' SQ FT';

        case 'lotsize':
            var lotsize = listing.lot_size;

            if(lotsize < 100) {
                lotsize = lotsize * 43560;
            }

            lotsize = String(lotsize).replace(/[^0-9]+/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',');

            return _.startCase(value) + ' - ' + lotsize + ' SQ FT';

        case 'hometype':
            if(!metThreshold) {
                return listing.sub_type.toLowerCase() === 'single family detached' ? 'Detached' : 'Attached';
            } else {
                return _.startCase(value);
            }

        default:
            return _.startCase(value);
    }
}

/*
Returns an object giving you the reason and type (why, whyNot)
ex.
{
    title: 'LOT SIZE',
    reason: 'I see a garden in your future.',
    type: 'why',
    value: 'small'
}

@function whyAndWhyNot
@param {Listing} listing
@param {Boolean} metThreshold
@param {String} key - ex. whatsimportant
@param {*} value - The value that was selected for the key
@returns {Object}
*/
function whyAndWhyNot(listing, metThreshold, key, value) {
    var reason;
    var title;
    var type;

    if(metThreshold === true) {
        type = 'why';
    } else if(metThreshold === false) {
        type = 'whyNot';
    } else {
        return false;
    }

    if(~['price', 'sqfeet', 'schools'].indexOf(key)) {
        reason = _.sampleSize(reasons[key][type], 1)[0];
        title = reasons[key].title;
    } else if(reasons[key] && reasons[key][value] && reasons[key][value][type]) {
        reason = _.sampleSize(reasons[key][value][type], 1)[0];
        title = reasons[key][value].title;
    }

    if(reason) {
        return {
            title: title,
            reason: reason,
            type: type,
            value: formatValue(listing, metThreshold, key, value)
        };
    } else {
        return false;
    }

}


module.exports = whyAndWhyNot;
